import moment from 'moment'
import STATICS from '../statics'

const formatAuctionDate = (auctionStartDate, auctionEndDate) => {
  if (!auctionStartDate) {
    return STATICS.TBD
  }

  const sameDayAuction = auctionStartDate.isSame(auctionEndDate, 'day')
  const startDate = moment(auctionStartDate, 'YYYY-MM-DD').format('MMM Do')
  const endDate = moment(auctionEndDate, 'YYYY-MM-DD').format('MMM Do')

  return sameDayAuction || !auctionEndDate
    ? startDate
    : [startDate, STATICS.TO_LABEL, endDate].join(' ')
}

export { formatAuctionDate }
